import {
    Button,
    Input,
    InputNumber,
    Radio,
    Typography,
    Space,
    Modal,
    Row,
    Col
} from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState, useContext } from "react";
import { PublicContext } from "../PublicContext";
import "../../styles/custom.css";
import HotPepperIcon from '../HotPepperIcon';

export default function MenuItem({
    menuItemProp,
    selectedPromo,
    setOpenDrawer,
}) {
    const [open, setOpen] = useState(true);
    const {
        products,
        promotionProducts,
        cartNum,
        setCartNum,
        cart,
        setCart,
        setCartPrice,
        setSpinning,
        openNotification,
        selectedStore
    } = useContext(PublicContext);
    const [placement, setPlacement] = useState("left");
    const [isPromo, setIsPromo] = useState(false);
    const { TextArea } = Input;
    const [orderQuantity, setOrderQuantity] = useState(1);
    //const cart = useRef(JSON.parse(localStorage.getItem("cart")) || []);
    //const [cartState, setCart] = useState();
    const [count, setCount] = useState(0);
    const [specialInstruction, setSpecialInstruction] = useState("");
    const [selectedFreeItem, setSelectedFreeItem] = useState(1);
    const [instructionError, setInstructionError] = useState("");
    const [isAlcoholic, setIsAlcoholic] = useState(false);
    const handleSelectedFreeItemChange = (e) => {
        //console.log(e.target.value);
        const rowId = e.target.value;
        setSelectedFreeItem(rowId);
    };

    const onClose = () => {
        setOrderQuantity(1);
        setOpen(false);
        setOpenDrawer(false);
    };

    const onChange = (e) => {
        setPlacement(e.target.value);
    };

    const handleDecrement = () => {
        setCount(count - 1);
    };

    const handleIncrement = () => {
        setCount(count + 1);
    };

    const addToCart = async () => {
        if (window.gtag) {
            window.gtag('event', 'MenuItemAddToCart', {
                event_category: 'Button',
                event_label: 'MenuItemAddToCart',
            });
        }
        //console.log(menuItemProp);
        setSpinning(true);
        let postData = [];
        if (selectedPromo != null) {
            let freeItem = products.find((p) => p.productCode === selectedFreeItem);
            postData.push({
                ProductCode: menuItemProp.productCode,
                ProductName: menuItemProp.productName,
                Quantity: orderQuantity,
                SingleProductPrice: menuItemProp.price,
                ItemPromoType: "BuyX",
                LinkedPromoProductId: freeItem.productCode,
                SpecialInstruction: specialInstruction
            });
            postData.push({
                ProductCode: freeItem.productCode,
                ProductName: freeItem.productName,
                Quantity: orderQuantity,
                SingleProductPrice: 0,
                ItemPromoType: "GetY",
                LinkedPromoProductId: menuItemProp.productCode,
            });
        }
        else {
            postData = [
                {
                    ProductCode: menuItemProp.productCode,
                    ProductName: menuItemProp.productName,
                    Quantity: orderQuantity,
                    SingleProductPrice: menuItemProp.price,
                    SpecialInstruction: specialInstruction
                    // ItemPromoType: "BuyX/GetY"
                },
            ];
        }
        //console.log(JSON.stringify(postData));
        await fetch("api/Carts/add-to-cart", {
            // await fetch("api/<OrderController>", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                Cart: postData,
                OrderType: sessionStorage.getItem("deliveryOrPickUp"),
                StoreCode: JSON.parse(sessionStorage.getItem("selectedStore")).storeCode
            }),
        })
            .then(async (response) => {
                setSpinning(false);
                // console.log(response);
                const responseData = await response.json();
                //console.log(responseData);
                setCart(responseData);

                const totalQuantity = responseData.reduce(
                    (acc, obj) => acc + obj.quantity,
                    0
                );

                const numberAdded = totalQuantity - cartNum;

                setCartNum(totalQuantity);
                setCartPrice(responseData[0].orderSubtotal);

                if (numberAdded > orderQuantity) {
                    if (orderQuantity > 1) {
                        openNotification("success", orderQuantity + " items and promotion are added!");
                        //messageApi.info(numberAdded + " items removed!");
                    } else {
                        openNotification("success", orderQuantity + " item and promotion are added!");
                        //messageApi.info(numberAdded + " item removed!");
                    }
                }
                else {
                    if (orderQuantity > 1) {
                        openNotification("success", orderQuantity + " items are added!");
                        //messageApi.info(numberAdded + " items removed!");
                    } else {
                        openNotification("success", orderQuantity + " item is added!");
                        //messageApi.info(numberAdded + " item removed!");
                    }
                }

                localStorage.setItem("cart", JSON.stringify(responseData));

                onClose();

            })
            .catch((error) => {
                setSpinning(false);
                openNotification("error", "Something went wrong. Please try again.");
                //console.error(error);
                // setSubmitDistabled(false);
            });

        // let cart_index = cart.current.findIndex(
        //   (obj) => obj.product.id === menuItemProp.id
        // );
        // console.log(cart_index);
        // if (cart_index === -1) {
        //   cart.current.push({
        //     product: menuItemProp,
        //     quantity: orderQuantity,
        //     specialInstruction: specialInstruction,
        //   });
        // } else {
        //   cart.current[cart_index].quantity += orderQuantity;
        // }
        // setCart(cart.current);
        // if (orderQuantity > 1) {
        //   messageApi.info(orderQuantity + " items added!");
        // } else {
        //   messageApi.info(orderQuantity + " item added!");
        // }

        // setCartNum(cartNum + orderQuantity);

        // localStorage.setItem("cart", JSON.stringify(cart.current));
    };

    useEffect(() => {
        if (menuItemProp.productCategoryId === 15 || menuItemProp.productCategoryId === 16) {
            setIsAlcoholic(true);
        }
    }, []);

    useEffect(() => {
        if (selectedPromo != null) {
            //console.log("Promo True");
            let promoId = promotionProducts.filter(
                (pp) => pp.promotionId === selectedPromo.id
            ).find(pp => pp.getProductCode != null).getProductCode;
            setSelectedFreeItem(promoId);
            setIsPromo(true);
        } else {
            //console.log("Promo False");
            setIsPromo(false);
        }
    }, [selectedPromo]);

    function renderPromoList() {
        //console.log("Menu Items render promolist");
        const promoProducts = promotionProducts.filter(
            (pp) => pp.promotionId === selectedPromo.id
        );
        return (
            <>
                <hr />
                <Typography.Title level={5}>Promotions</Typography.Title>
                <p>Choose one from the following for FREE!</p>
                <Radio.Group
                    onChange={handleSelectedFreeItemChange}
                    value={selectedFreeItem}
                >
                    <Space direction="vertical">
                        {promoProducts.map((pp) => {
                            if (pp.getProductCode != null) {
                                const product = products.find(
                                    (p) => p.productCode === pp.getProductCode
                                );
                                return (
                                    // <Row className="d-flex justify-content-between align-items-center">
                                    <Radio
                                        key={pp.getProductCode}
                                        value={pp.getProductCode}
                                    >
                                        <Space direction="horizontal">
                                            <img
                                                width="100px"
                                                alt={product.productName}
                                                src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(product.pictureURL)}`}
                                                // fluid
                                                className="rounded-3"
                                                onError={({ currentTarget }) => {
                                                    currentTarget.style.display = 'none';
                                                }}
                                            />
                                            <Space direction="vertical">
                                                <Typography level={5} className="text-black flex-wrap">
                                                    {product.productName}
                                                </Typography>
                                                <div className="w-100">
                                                    <strike>$ {product.price.toFixed(2)}</strike> Free!
                                                </div>
                                            </Space>
                                        </Space>
                                    </Radio>
                                    // </Row>
                                );
                            }
                        })}
                    </Space>
                </Radio.Group>
            </>
        );
    }

    //    title = {
    //                    < img
    //    alt = { menuItemProp.productName }
    //    src = {`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(menuItemProp.pictureURL)}`
    //}
    //className = { 'rounded-3 menuItemImage'}
    //onError = {({ currentTarget }) => {
    //    currentTarget.style.display = 'none';
    //}}
    ///>
    //                }

    return (
        <>
            <Modal
                footer={
                    <div className="menuItem_addToCart w-100 d-flex align-items-center">
                        <div className="menuItem_input">
                            {/*<h6 className="menuItem_price">Quantity</h6>*/}
                            <Button
                                color="link"
                                className="px-2 qty-btn"
                                shape="circle"
                                style={{ fontSize: '16px', background: "transparent", boxShadow: "none" }}
                                onClick={() => {
                                    if (orderQuantity > 1) {
                                        setOrderQuantity(orderQuantity - 1);
                                    }
                                }}
                                icon={<MinusOutlined style={{ fontSize: '18px' }} />}
                            />
                            <Typography.Title
                                level={4}
                                className="align-items-center"
                                style={{ paddingLeft: "5px", paddingRight: "10px", margin: "0", minWidth: "26px" }}
                            >
                                {orderQuantity}
                            </Typography.Title>
                            <Button
                                color="link"
                                className="px-2 qty-btn"
                                shape="circle"
                                style={{ fontSize: '16px', background: "transparent", boxShadow: "none" }}
                                onClick={() => {
                                    setOrderQuantity(orderQuantity + 1);
                                }}
                                icon={<PlusOutlined style={{ fontSize: '18px' }} />}
                            />
                        </div>

                        <Button
                            className="add-to-cart-btn menuItem_button btn-tertiary"
                            shape="round"
                            onClick={addToCart}
                        >
                            Add to cart - ${(menuItemProp.price * orderQuantity).toFixed(2)}
                        </Button>

                    </div>
                }
                // closable={false}
                onCancel={onClose}
                open={open}
                scrollable={true}
                styles={{ height: '100vh', overflowY: 'auto' }}
                // key={placement}
                className="productModal"
            >
                <Row>
                    <Col xs={24} sm={24} md={24} lg={12} className="productModalCol">
                        < img
                            alt={menuItemProp.productName}
                            src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(menuItemProp.pictureURL)}`
                            }
                            className={'rounded-3 menuItemImage'}
                            onError={({ currentTarget }) => {
                                currentTarget.style.display = 'none';
                            }}
                        />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} className="productModalCol">
                        <div>
                            <Typography.Title level={3} style={{ maxWidth: "90%" }}>{menuItemProp.productName} <HotPepperIcon value={menuItemProp.spiciness} /></Typography.Title>
                            <Typography.Title level={4}>{`$${menuItemProp.price}`}</Typography.Title>
                            <Typography style={{ flex: "1" }}>{menuItemProp.calorie}</Typography>
                            <Typography>{menuItemProp.description}</Typography>
                            {/*{isAlcoholic && <Typography>Must be of 19 years of age or older to purchase alcohol.</Typography>}*/}
                        </div>

                        <hr></hr>

                        <div>
                            <Typography.Title level={5}>Special Instructions:</Typography.Title>
                            <TextArea
                                rows={4}
                                placeholder="Enter special instructions here"
                                maxLength={200}
                                value={specialInstruction}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    const asciiValue = value.replace(/[^\x00-\x7F]/g, '');
                                    if (value !== asciiValue) {
                                        setInstructionError("Please only enter standard alphanumeric characters.");
                                    }
                                    else {
                                        let cart_index = cart.findIndex(
                                            (obj) => obj.productCode === menuItemProp.productCode
                                        );
                                        if (cart_index !== -1) {
                                            cart[cart_index].specialInstruction =
                                                asciiValue;
                                        }
                                        setInstructionError("");
                                        setSpecialInstruction(asciiValue);
                                        setCart(cart);
                                        localStorage.setItem("cart", JSON.stringify(cart));
                                    }
                                }}
                            />
                            <Typography style={{ color: "red" }}>{instructionError}</Typography>
                        </div>

                        {isPromo && renderPromoList()}
                        {/* {renderAddons()} */}
                    </Col>
                </Row>
            </Modal>
        </>
    );
}
